import { API_PATHS } from "../constants/api-paths";
import { request } from "../core/api.client";

interface ApiResponseItem {
  content: string;
  cta_url: string;
}

interface InpageSearchResponse {
  responses: ApiResponseItem[];
}

export const getInPageSearchData = async (query: string): Promise<ApiResponseItem[]> => {
  const data = {
    section: window.location.href,
    query,
  };

  const response = await request<InpageSearchResponse>({
    method: "POST",
    url: API_PATHS.inPageSearchApi,
    data,
  });

  // response.data is InpageSearchResponse
  return response.data.responses;
};
